/**
 * Ubicar en el tiempo un hilo de conversación largo.
 *
 * El copiloto guarda UNA conversación por usuario, así que el historial que se
 * abre puede tener semanas. Sin fecha, los turnos se leen como un revoltijo: no
 * hay forma de saber si lo último que dijo es de hoy o del mes pasado.
 *
 * Los turnos que el panel arma en el momento —lo que escribe la persona, lo que
 * contesta el copiloto sobre un tema— y los que vienen del historial no siempre
 * traen fecha. Un turno sin fecha no abre un día nuevo: se queda en el grupo que
 * venía, porque un separador que miente es peor que no tener separador.
 */

const clave = (d) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;

/** Lo que llega como fecha del turno: Date, ISO, ms, o Timestamp de Firestore. */
export function fechaDelTurno(valor) {
  if (valor == null) return null;
  if (valor instanceof Date) return Number.isNaN(valor.getTime()) ? null : valor;
  if (typeof valor === 'object') {
    const seconds = valor.seconds ?? valor._seconds;
    return typeof seconds === 'number' ? new Date(seconds * 1000) : null;
  }
  const d = new Date(valor);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** "Hoy", "Ayer", "Jueves 24 de septiembre", "24 de septiembre de 2025". */
export function etiquetaDeDia(fecha, ahora = new Date()) {
  const dias = (a, b) => Math.round(
    (new Date(a.getFullYear(), a.getMonth(), a.getDate()) - new Date(b.getFullYear(), b.getMonth(), b.getDate()))
    / 86400000,
  );
  const delta = dias(ahora, fecha);
  if (delta === 0) return 'Hoy';
  if (delta === 1) return 'Ayer';

  const mismoAno = fecha.getFullYear() === ahora.getFullYear();
  const texto = fecha
    .toLocaleDateString('es-AR', mismoAno
      ? { weekday: 'long', day: 'numeric', month: 'long' }
      : { day: 'numeric', month: 'long', year: 'numeric' })
    .replace(', ', ' ');
  return texto.charAt(0).toUpperCase() + texto.slice(1);
}

/**
 * Intercala separadores de día entre los turnos del hilo. Devuelve la misma
 * lista con items `{ tipo: 'dia' }` adelante de cada cambio de día calendario.
 */
export function conSeparadoresDeDia(turnos, ahora = new Date()) {
  const salida = [];
  let dia = null;
  for (const turno of turnos) {
    const fecha = fechaDelTurno(turno.fecha);
    if (fecha) {
      const k = clave(fecha);
      if (k !== dia) {
        dia = k;
        salida.push({ tipo: 'dia', id: `dia-${k}`, etiqueta: etiquetaDeDia(fecha, ahora) });
      }
    }
    salida.push(turno);
  }
  return salida;
}
